import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import React from 'react';
import { useSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { DisplayComment } from '../../../../common/logs/comment';
import { propertyStatusOptions } from '../../../../data/data';
import { DisplayStatus } from '../../../../common/logs/status';
import { useGetLogsByProperty } from '../../../../hooks/query/get-logs-by-property-query.hook';
import { useAddCommentOnProperty } from '../../../../hooks/mutation/add-comment-on-property-mutation.hook';
import { RichTextCustomLogs } from '../../../../common/logs/rich-text-custom-logs';

interface IFormInput {
  log_message: string
}

function Logs() {
  const [searchParams] = useSearchParams();
  const {
    control, handleSubmit, setValue, watch,
  } = useForm<IFormInput>({
    mode: 'onChange',
  });
  const queryInfo = useGetLogsByProperty(searchParams.get('propertyId'));
  const { enqueueSnackbar } = useSnackbar();
  const mutate = useAddCommentOnProperty({
    onSuccess: (resp: any) => {
      setValue('log_message', '');
      queryInfo.refetch().then((r) => r);
    },
    onError: (err: any) => {
      enqueueSnackbar(err.message);
    },
  });

  const onSubmit = (form: any) => {
    const formValid: any = {
      data: {
        comment: form?.log_message,
        propertyId: searchParams.get('propertyId'),
      },
    };
    mutate({ ...formValid });
  };

  return (
    <Box>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <RichTextCustomLogs
          name="log_message"
          control={control}
          watch={watch}
        />
      </Box>
      {queryInfo?.data?.getLogsByProperty?.map((e, i) => {
        if ('status' in e.action) {
          return (
            <Box key={e._id}>
              <DisplayStatus
                // @ts-ignore
                label={propertyStatusOptions?.find((f) => f?.value === e?.action?.status)?.label}
                createdAt={e?.createdAt && format(new Date(Number(e.createdAt)), 'dd MMMM yyyy', { locale: fr })}
                mail={e?.user?.email}
                display={i + 1 === queryInfo?.data?.getLogsByProperty?.length ? 'none' : 'inherit'}
              />
            </Box>
          );
        }
        if ('comment' in e.action) {
          return (
            <Box key={e._id}>
              <DisplayComment
                picto={e?.user?.email && e?.user?.email.length > 1 ? `${e.user.email[0]}${e.user.email[1]}` : '...'}
                mail={e?.user?.email}
                createdAt={e.createdAt && format(new Date(Number(e.createdAt)), 'dd MMMM yyyy', { locale: fr })}
                comment={e?.action?.comment}
                display={i + 1 === queryInfo?.data?.getLogsByProperty?.length ? 'none' : 'inherit'}
              />
            </Box>
          );
        }
        return <Box key={e._id} />;
      })}
    </Box>
  );
}

export {
  Logs,
};
